// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OgImageUploader-space1-JiZOg {
	margin-bottom: 6px !important;
}

.OgImageUploader-space2-ux6cS {
	margin-bottom: 12px !important;
}

.OgImageUploader-space3-lnVHP {
	margin-bottom: 18px !important;
}

.OgImageUploader-space4-sbvDA {
	margin-bottom: 24px !important;
}

.OgImageUploader-space5-f4Cy6 {
	margin-bottom: 30px !important;
}

.OgImageUploader-space6-fdlcE {
	margin-bottom: 36px !important;
}

.OgImageUploader-space7-xxolz {
	margin-bottom: 42px !important;
}

.OgImageUploader-spaceTop8-VvhZG {
	margin-bottom: 48px !important;
}

.OgImageUploader-spaceTop1-MzMbT {
	margin-top: 6px !important;
}

.OgImageUploader-spaceTop2-Z8dLY {
	margin-top: 12px !important;
}

.OgImageUploader-spaceTop3-IbTJL {
	margin-top: 18px !important;
}

.OgImageUploader-spaceTop4-PbTet {
	margin-top: 24px !important;
}

.OgImageUploader-spaceTop5-Hrgcd {
	margin-top: 30px !important;
}

.OgImageUploader-spaceTop6-DrW0U {
	margin-top: 36px !important;
}

.OgImageUploader-spaceTop7-O4hfK {
	margin-top: 42px !important;
}

.OgImageUploader-spaceTop8-VvhZG {
	margin-top: 48px !important;
}

.OgImageUploader-noMargin-s0QdZ {
	margin: 0px !important;
}

.OgImageUploader-padding1-yERU4 {
	padding-bottom: 6px !important;
}

.OgImageUploader-padding2-LWX0t {
	padding-bottom: 12px !important;
}

.OgImageUploader-padding3-WEySZ {
	padding-bottom: 18px !important;
}

.OgImageUploader-padding4-i_FOy {
	padding-bottom: 24px !important;
}

.OgImageUploader-padding5-YkHK3 {
	padding-bottom: 30px !important;
}

.OgImageUploader-padding6-_kGGX {
	padding-bottom: 36px !important;
}

.OgImageUploader-padding7-zN3nR {
	padding-bottom: 42px !important;
}

.OgImageUploader-paddingTop1-yiorc {
	padding-top: 6px !important;
}

.OgImageUploader-paddingTop2-uQNBK {
	padding-top: 12px !important;
}

.OgImageUploader-paddingTop3-i6rZ0 {
	padding-top: 18px !important;
}

.OgImageUploader-paddingTop4-paYIN {
	padding-top: 24px !important;
}

.OgImageUploader-paddingTop5-z7fO_ {
	padding-top: 30px !important;
}

.OgImageUploader-paddingTop6-GUHK2 {
	padding-top: 36px !important;
}

.OgImageUploader-paddingTop7-Pc73o {
	padding-top: 42px !important;
}

.OgImageUploader-noPadding-KWSgv {
	padding: 0px !important;
}

.OgImageUploader-textBold-dK6ja {
	font-weight: 500 !important;
}

.OgImageUploader-textBolder-pAlz4 {
	font-weight: 700 !important;
}

.OgImageUploader-textNormal-kL2uH {
	font-weight: normal !important;
}

.OgImageUploader-spaceBottom20-TsQX1 {
	margin-bottom: 20px;
}

.OgImageUploader-spaceBottom10-IUwsX {
	margin-bottom: 10px;
}

.OgImageUploader-marginNone-F9hbp {
	margin: 0;
}

.OgImageUploader-spaceBottom15-H2BwS {
	margin-bottom: 15px;
}

.OgImageUploader-marginTopNone-Rbbcm {
	margin-top: 0;
}

.OgImageUploader-spaceTop11-ufvlt {
	margin-top: 11px;
}

.OgImageUploader-spaceTop21-maIw9 {
	margin-top: 21px;
}

.OgImageUploader-spaceTop20-Mz4aA {
	margin-top: 20px;
}

.OgImageUploader-spaceTop10-R9aXP {
	margin-top: 10px;
}

/*New Design Text Colors */

.OgImageUploader-textDarkBlue-r3htW {
	color: rgb(20, 39, 94) !important;
}

.OgImageUploader-textLightBlue-xqFRZ {
	color: rgb(57, 87, 106) !important;
}

.OgImageUploader-textLightSandleGreen-q0Gwy {
	color: rgb(76, 86, 41) !important;
}

.OgImageUploader-textLightBrown-hcEem {
	color: rgb(115, 79, 33) !important;
}

.OgImageUploader-textMediumMaroon-hLkeD {
	color: rgb(87, 37, 51) !important;
}

.OgImageUploader-textBrown-HzoMv {
	color: rgb(160, 47, 24) !important;
}

.OgImageUploader-textMaroon-APLET {
	color: rgb(155, 49, 67) !important;
}

.OgImageUploader-textDarkBrown-XHa03 {
	color: rgb(83, 18, 16) !important;
}

.OgImageUploader-textMediumBrown-bI9Io {
	color: rgb(142, 28, 10) !important;
}

.OgImageUploader-textSkyBlue-CUJ5m {
	color: rgb(37, 117, 141) !important;
}

.OgImageUploader-textGray-Ltxii {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `OgImageUploader-space1-JiZOg`,
	"space2": `OgImageUploader-space2-ux6cS`,
	"space3": `OgImageUploader-space3-lnVHP`,
	"space4": `OgImageUploader-space4-sbvDA`,
	"space5": `OgImageUploader-space5-f4Cy6`,
	"space6": `OgImageUploader-space6-fdlcE`,
	"space7": `OgImageUploader-space7-xxolz`,
	"spaceTop8": `OgImageUploader-spaceTop8-VvhZG`,
	"spaceTop1": `OgImageUploader-spaceTop1-MzMbT`,
	"spaceTop2": `OgImageUploader-spaceTop2-Z8dLY`,
	"spaceTop3": `OgImageUploader-spaceTop3-IbTJL`,
	"spaceTop4": `OgImageUploader-spaceTop4-PbTet`,
	"spaceTop5": `OgImageUploader-spaceTop5-Hrgcd`,
	"spaceTop6": `OgImageUploader-spaceTop6-DrW0U`,
	"spaceTop7": `OgImageUploader-spaceTop7-O4hfK`,
	"noMargin": `OgImageUploader-noMargin-s0QdZ`,
	"padding1": `OgImageUploader-padding1-yERU4`,
	"padding2": `OgImageUploader-padding2-LWX0t`,
	"padding3": `OgImageUploader-padding3-WEySZ`,
	"padding4": `OgImageUploader-padding4-i_FOy`,
	"padding5": `OgImageUploader-padding5-YkHK3`,
	"padding6": `OgImageUploader-padding6-_kGGX`,
	"padding7": `OgImageUploader-padding7-zN3nR`,
	"paddingTop1": `OgImageUploader-paddingTop1-yiorc`,
	"paddingTop2": `OgImageUploader-paddingTop2-uQNBK`,
	"paddingTop3": `OgImageUploader-paddingTop3-i6rZ0`,
	"paddingTop4": `OgImageUploader-paddingTop4-paYIN`,
	"paddingTop5": `OgImageUploader-paddingTop5-z7fO_`,
	"paddingTop6": `OgImageUploader-paddingTop6-GUHK2`,
	"paddingTop7": `OgImageUploader-paddingTop7-Pc73o`,
	"noPadding": `OgImageUploader-noPadding-KWSgv`,
	"textBold": `OgImageUploader-textBold-dK6ja`,
	"textBolder": `OgImageUploader-textBolder-pAlz4`,
	"textNormal": `OgImageUploader-textNormal-kL2uH`,
	"spaceBottom20": `OgImageUploader-spaceBottom20-TsQX1`,
	"spaceBottom10": `OgImageUploader-spaceBottom10-IUwsX`,
	"marginNone": `OgImageUploader-marginNone-F9hbp`,
	"spaceBottom15": `OgImageUploader-spaceBottom15-H2BwS`,
	"marginTopNone": `OgImageUploader-marginTopNone-Rbbcm`,
	"spaceTop11": `OgImageUploader-spaceTop11-ufvlt`,
	"spaceTop21": `OgImageUploader-spaceTop21-maIw9`,
	"spaceTop20": `OgImageUploader-spaceTop20-Mz4aA`,
	"spaceTop10": `OgImageUploader-spaceTop10-R9aXP`,
	"textDarkBlue": `OgImageUploader-textDarkBlue-r3htW`,
	"textLightBlue": `OgImageUploader-textLightBlue-xqFRZ`,
	"textLightSandleGreen": `OgImageUploader-textLightSandleGreen-q0Gwy`,
	"textLightBrown": `OgImageUploader-textLightBrown-hcEem`,
	"textMediumMaroon": `OgImageUploader-textMediumMaroon-hLkeD`,
	"textBrown": `OgImageUploader-textBrown-HzoMv`,
	"textMaroon": `OgImageUploader-textMaroon-APLET`,
	"textDarkBrown": `OgImageUploader-textDarkBrown-XHa03`,
	"textMediumBrown": `OgImageUploader-textMediumBrown-bI9Io`,
	"textSkyBlue": `OgImageUploader-textSkyBlue-CUJ5m`,
	"textGray": `OgImageUploader-textGray-Ltxii`
};
module.exports = ___CSS_LOADER_EXPORT___;
